import { ConsultationType } from '../../../../../../types/models/consultations/consultation.types';
import { CreateConsultSecondStepItemData } from '../CreateConsultSecondStep.types';

export interface CreateConsultSecondStepItemProps {
  key?: number;
  index: number;
  isLast: boolean;
  type: ConsultationType | ConsultationItemType;
  data: CreateConsultSecondStepItemData;
  onChange: (indexToUpdate: number, data: CreateConsultSecondStepItemData) => void;
  onAdd: (type: ConsultationItemType) => void;
  onRemove: (index: number) => void;
}

export interface CreateConsultSecondStepVariantItemProps
  extends Omit<CreateConsultSecondStepItemProps, 'type' | 'itemsLength'> {
  isLast: boolean;
}

export enum ConsultationItemType {
  Service = 'Service',
  Products = 'Produit'
}
